<template>
  <div>
    <Header></Header>
    <div>
      <img class="lbt" :src="baseURL+solution.mainDrawingSrc" alt="" />
    </div>
    <div class="body">
      <div>
        <div class="cpszh">{{solution.title}}分类</div>
        <div class="bodyTitle">
          <div class="product">{{solution.eTitle}}</div>
<!--          <div class="more">-->
<!--            <div class="gdal">更多服务</div>-->
<!--            <div>></div>-->
<!--          </div>-->
        </div>
      </div>
      <div class="bodyTopContent">
        <div class="jjfaFirH1" v-if="classList.length>0">
          <div class="jjfaFirH1M"></div>
          <img class="jjfah1" :src="baseURL+classList[0].fileSrc" alt="" />
          <div class="jjfaFirH1Font1">{{classList[0].title}}</div>
          <div class="jjfaFirH1Font2">
            {{classList[0].introduce}}
          </div>
          <!-- <div class="jjfaFirH1Font3">了解更多</div> -->
        </div>
        <div class="jjfaFirH2" v-if="classList.length>1">
          <div class="jjfaFirH2M"></div>
          <img class="jjfah2" :src="baseURL+classList[1].fileSrc" alt="" />
          <div class="jjfaFirH2Font1">{{classList[1].title}}</div>
          <div class="jjfaFirH2Font2">
            {{classList[1].introduce}}
          </div>
          <!-- <div class="jjfaFirH2Font3">了解更多</div> -->
        </div>
      </div>
      <div class="bodyBottomContent">
        <div>
          <div class="jjfaFirH3" v-if="classList.length>2">
            <div class="jjfaFirH3M"></div>
            <img class="jjfah3" :src="baseURL+classList[2].fileSrc" alt="" />
            <div class="jjfaFirH3Font1">{{classList[2].title}}</div>
            <div class="jjfaFirH3Font2">
              {{classList[2].introduce}}
            </div>
            <!-- <div class="jjfaFirH3Font3">了解更多</div> -->
          </div>
          <div class="jjfaFirH4" v-if="classList.length>5">
            <div class="jjfaFirH4M"></div>
            <img class="jjfah4" :src="baseURL+classList[5].fileSrc" alt="" />
            <div class="jjfaFirH4Font1">{{classList[5].title}}</div>
            <div class="jjfaFirH4Font2">
              {{classList[5].introduce}}
            </div>
            <!-- <div class="jjfaFirH4Font3">了解更多</div> -->
          </div>
        </div>
        <div>
          <div class="jjfaFirH5" v-if="classList.length>3">
            <div class="jjfaFirH5M"></div>
            <img class="jjfah5" :src="baseURL+classList[3].fileSrc" alt="" />
            <div class="jjfaFirH5Font1">{{classList[3].title}}</div>
            <div class="jjfaFirH5Font2">
              {{classList[3].introduce}}
            </div>
            <!-- <div class="jjfaFirH5Font3">了解更多</div> -->
          </div>
          <div class="jjfaFirH6" v-if="classList.length>4">
            <div class="jjfaFirH6M"></div>
            <img class="jjfah6" :src="baseURL+classList[4].fileSrc" alt="" />
            <div class="jjfaFirH6Font1">{{classList[4].title}}</div>
            <div class="jjfaFirH6Font2">
              {{classList[4].introduce}}
            </div>
            <!-- <div class="jjfaFirH6Font3">了解更多</div> -->
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "@/views/header.vue";
import Footer from "@/views/footer.vue";
import {getSolution,getSolutionClassificationPage} from "@/api/open";
export default {
  components: {
    Header,
    Footer,
  },
  watch: {
    '$route' (to, from) { //监听URL地址栏参数变化
      if (this.$route.query.solutionId) {
        this.solutionId = this.$route.query.solutionId
        this.getById()
        this.getClassList()
      }
    }
  },
  data() {
    return {
      solutionId:null,
      solution:{},
      classList:[],
      baseURL: process.env.VUE_APP_BASE_API,
    };
  },
  created() {
    this.solutionId = this.$route.query.solutionId
    this.getById()
    this.getClassList()
  },
  methods: {
    getById(){
      getSolution({id:this.solutionId}).then(res=>{
        this.solution = res.data
      })
    },
    getClassList(){
      getSolutionClassificationPage({solutionId:this.solutionId}).then(res=>{
        this.classList = res.rows
      })
    }
  },
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
}
.lbt {
  width: 100%;
}
.body {
  width: 1200px;
  margin: 0 auto;
  padding-bottom: 80px;
  background: #fff !important;
}
.cpszh {
  font-size: 24px;
  padding: 40px 0 4px 32px;
  color: #183f85;
  letter-spacing: 1px;
}
.bodyTitle {
  display: flex;
  justify-content: space-between;
  margin-right: 32px;
}
.product {
  font-size: 24px;
  color: #bfbfbf;
  margin-left: 32px;
  letter-spacing: 1px;
}
.more {
  display: flex;
}
.gdal {
  margin-right: 4px;
  font-size: 14px;
  color: #7d7d7d;
}
.bodyTopContent {
  margin-top: 24px;
  display: flex;
}
.jjfah1 {
  width: 762px;
  height: 500px;
  margin: 0 24px 24px 32px;
  border-top-left-radius: 20px;
  border-bottom-right-radius: 20px;
  position: absolute;
  top: 0;
}
.jjfah2 {
  width: 350px;
  height: 500px;
  margin: 0 0 24px 0;
  border-top-left-radius: 20px;
  border-bottom-right-radius: 20px;
  position: absolute;
  top: 0;
}
.bodyBottomContent {
  display: flex;
  margin-top: 0;
}
.jjfah3 {
  width: 568px;
  height: 784px;
  margin: 0 24px 24px 32px;
  border-top-left-radius: 20px;
  border-bottom-right-radius: 20px;
  position: absolute;
  top: 0;
}
.jjfah4 {
  width: 568px;
  height: 255px;
  margin: 0 24px 0 32px;
  border-top-left-radius: 20px;
  border-bottom-right-radius: 20px;
  position: absolute;
  top: 0;
}
.jjfah5 {
  width: 545px;
  height: 380px;
  margin: 0 0 24px 0;
  border-top-left-radius: 20px;
  border-bottom-right-radius: 20px;
  position: absolute;
  top: 0;
}
.jjfah6 {
  width: 545px;
  height: 659px;
  border-top-left-radius: 20px;
  border-bottom-right-radius: 20px;
  position: absolute;
  top: 0;
}
.jjfaFirH1 {
  position: relative;
  transition: all 0.5s;
}
.jjfaFirH1:hover{
  transform: scale(1.05);
}
.jjfaFirH1Font1 {
  position: absolute;
  top: 24px;
  left: 56px;
  font-size: 24px;
  color: #ffffff;
  line-height: 30px;
  letter-spacing: 1px;
  z-index: 2;
}
.jjfaFirH1Font2 {
  position: absolute;
  bottom: 56px;
  left: 56px;
  width: 688px;
  color: #ffffff;
  line-height: 30px;
  letter-spacing: 1px;
  z-index: 2;
}
.jjfaFirH1Font3 {
  position: absolute;
  bottom: 40px;
  right: 40px;
  color: #ffffff;
  line-height: 17px;
  z-index: 2;
  cursor: pointer;
}
.jjfaFirH2 {
  position: relative;
  transition: all 0.5s;
}
.jjfaFirH2:hover{
  transform: scale(1.05);
}
.jjfaFirH2Font1 {
  position: absolute;
  top: 24px;
  left: 24px;
  font-size: 24px;
  color: #ffffff;
  line-height: 30px;
  letter-spacing: 1px;
  z-index: 2;
}
.jjfaFirH2Font2 {
  position: absolute;
  bottom: 56px;
  left: 24px;
  width: 309px;
  color: #ffffff;
  line-height: 30px;
  letter-spacing: 1px;
  z-index: 2;
}
.jjfaFirH2Font3 {
  position: absolute;
  bottom: 40px;
  right: 16px;
  color: #ffffff;
  line-height: 17px;
  z-index: 2;
  cursor: pointer;
}
.jjfaFirH3 {
  position: relative;
  transition: all 0.5s;
}
.jjfaFirH3:hover{
  transform: scale(1.05);
}
.jjfaFirH3Font1 {
  position: absolute;
  top: 24px;
  left: 56px;
  font-size: 24px;
  color: #ffffff;
  line-height: 30px;
  letter-spacing: 1px;
  z-index: 2;
}
.jjfaFirH3Font2 {
  position: absolute;
  bottom: 32px;
  left: 56px;
  width: 501px;
  color: #ffffff;
  line-height: 30px;
  letter-spacing: 1px;
  z-index: 2;
}
.jjfaFirH3Font3 {
  position: absolute;
  bottom: 40px;
  right: 40px;
  color: #ffffff;
  line-height: 17px;
  z-index: 2;
  cursor: pointer;
}
.jjfaFirH4 {
  position: relative;
  transition: all 0.5s;
}
.jjfaFirH4:hover{
  transform: scale(1.05);
}
.jjfaFirH4Font1 {
  position: absolute;
  top: 24px;
  left: 56px;
  font-size: 24px;
  color: #ffffff;
  line-height: 30px;
  letter-spacing: 1px;
  z-index: 2;
}
.jjfaFirH4Font2 {
  position: absolute;
  bottom: 32px;
  left: 56px;
  width: 529px;
  color: #ffffff;
  line-height: 30px;
  letter-spacing: 1px;
  z-index: 2;
}
.jjfaFirH4Font3 {
  position: absolute;
  bottom: 16px;
  right: 40px;
  color: #ffffff;
  line-height: 17px;
  z-index: 2;
  cursor: pointer;
}
.jjfaFirH5 {
  position: relative;
  transition: all 0.5s;
}
.jjfaFirH5:hover{
  transform: scale(1.05);
}
.jjfaFirH5Font1 {
  position: absolute;
  top: 24px;
  left: 24px;
  font-size: 24px;
  color: #ffffff;
  line-height: 30px;
  letter-spacing: 1px;
  z-index: 2;
}
.jjfaFirH5Font2 {
  position: absolute;
  bottom: 56px;
  left: 24px;
  width: 500px;
  color: #ffffff;
  line-height: 30px;
  letter-spacing: 1px;
  z-index: 2;
}
.jjfaFirH5Font3 {
  position: absolute;
  bottom: 40px;
  right: 16px;
  color: #ffffff;
  line-height: 17px;
  z-index: 2;
  cursor: pointer;
}
.jjfaFirH6 {
  position: relative;
  transition: all 0.5s;
}
.jjfaFirH6:hover{
  transform: scale(1.05);
}
.jjfaFirH6Font1 {
  position: absolute;
  top: 24px;
  left: 24px;
  font-size: 24px;
  color: #ffffff;
  line-height: 30px;
  letter-spacing: 1px;
  z-index: 2;
}
.jjfaFirH6Font2 {
  position: absolute;
  bottom: 32px;
  left: 24px;
  width: 500px;
  color: #ffffff;
  line-height: 30px;
  letter-spacing: 1px;
  z-index: 2;
}
.jjfaFirH6Font3 {
  position: absolute;
  bottom: 16px;
  right: 16px;
  color: #ffffff;
  line-height: 17px;
  z-index: 2;
  cursor: pointer;
}
.jjfaFirH1M {
  width: 762px;
  height: 500px;
  background: linear-gradient(
    180deg,
    #000000 -150%,
    rgba(250, 250, 250, 0) 50%,
    #000000 150%
  );
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.2);
  border-radius: 20px 0px 20px 0px;
  margin: 0 24px 24px 32px;
  position: relative;
  z-index: 1;
}
.jjfaFirH2M {
  width: 350px;
  height: 500px;
  background: linear-gradient(
    180deg,
    #000000 -150%,
    rgba(250, 250, 250, 0) 50%,
    #000000 150%
  );
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.2);
  border-radius: 20px 0px 20px 0px;
  margin: 0 0 24px 0;
  position: relative;
  z-index: 1;
}
.jjfaFirH3M {
  width: 568px;
  height: 784px;
  background: linear-gradient(
    180deg,
    #000000 -150%,
    rgba(250, 250, 250, 0) 50%,
    #000000 150%
  );
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.2);
  border-radius: 20px 0px 20px 0px;
  margin: 0 24px 24px 32px;
  position: relative;
  z-index: 1;
}
.jjfaFirH4M {
  width: 568px;
  height: 255px;
  background: linear-gradient(
    180deg,
    #000000 -150%,
    rgba(250, 250, 250, 0) 50%,
    #000000 150%
  );
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.2);
  border-radius: 20px 0px 20px 0px;
  margin: 0 24px 0 32px;
  position: relative;
  z-index: 1;
}
.jjfaFirH5M {
  width: 545px;
  height: 380px;
  background: linear-gradient(
    180deg,
    #000000 -150%,
    rgba(250, 250, 250, 0) 50%,
    #000000 150%
  );
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.2);
  border-radius: 20px 0px 20px 0px;
  margin: 0 0 24px 0;
  position: relative;
  z-index: 1;
}
.jjfaFirH6M {
  width: 545px;
  height: 659px;
  background: linear-gradient(
    180deg,
    #000000 -150%,
    rgba(250, 250, 250, 0) 50%,
    #000000 150%
  );
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.2);
  border-radius: 20px 0px 20px 0px;
  /* margin: 0 0 24px 0; */
  position: relative;
  z-index: 1;
}
</style>
